module.exports = __webpack_public_path__ + "img/My-GDQ-Management.8f63389c.svg";